export default __webpack_public_path__ + "6cf56f09536e0d852a080ea0f5acb2bc.jpg";